import Templates from "./templatesTab";
import Reports from "./reportsTab";

export default [
  {
    name: "TEMPLATES",
    key: "1",
    icon: "",
    Component: Templates,
  },
  {
    name: "REPORTS",
    key: "2",
    icon: "",
    Component: Reports,
  },
];
